import styled from "styled-components";
import quoteBg from "../../../../assets/images/blog/quote.png";
import blogImage from "../../../../assets/images/blog/blog-07.jpg";

const BlogDetailsStyleWrapper = styled.div`
  background: #0d102d;

  .blog_post_details_wrapper {
    padding-top: 100px;
    padding-bottom: 110px;
  }
  color: rgba(255, 255, 255, 0.8);
  p {
    font-family: "Poppins";
    font-weight: 500;
    font-size: 16px;
    margin: 20px 0;
  }
  a {
    display: inline-block;
    font-family: "Poppins";
    color: #ffffff;
    transition: all 0.4s;
    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .post_thumbnail{
    background-image: url(${blogImage});
    height: 500px;
    object-fit: cover;
    width: 100%;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
  }

  .blog_details{
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
    background: #0d102d;
    padding: 50px;
    margin-top: -80px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #ffffff;
    margin: 40px 0 25px;
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
  }

  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }

  .blog_post_meta {
    display: flex;
    align-items: center;
    column-gap: 50px;
    text-transform: uppercase;
    // margin: 50px 0 10px;
    a,
    span {
      font-family: "Poppins";
      display: flex;
      align-items: center;
      column-gap: 15px;
      img {
        height: 20px;
      }
      svg {
        font-size: 1.2rem;
      }
    }
  }

  .post_title {
    width: 90%;
    font-size: 56px;
    font-weight: 700;
  }

  blockquote,
  .blockquote {
    display: flex;
    align-items: center;
    position: relative;
    margin: 30px 0 20px;
    p {
      font-style: italic;
      font-weight: 500;
      font-size: 22px;
      line-height: 36px;
      padding-left: 65px;
      color: #ffffff;
      margin: 0;
    }

    &::before {
      position: absolute;
      height: 86px;
      width: 20px;
      left: 0;
      top: auto;
      background: url(${quoteBg});
      background-size: contain;
      background-repeat: no-repeat;
      content: "";
    }
  }

  .blog_description {
    img {
      margin: 25px 0;
    }

    ul {
      font-weight: 500;
      li {
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 25px;
        &::before {
          position: absolute;
          height: 8px;
          width: 8px;
          left: 0;
          top: 50%;
          border-radius: 50%;
          background-color: #3a3b48;
          content: "";
          transform: translate(0, -50%);
        }

        span {
          margin-right: 5px;
        }
      }

      li + li {
        margin-top: 20px;
      }
    }
  }

  /* tags and share wrapper  */
  .post_tags_list {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 30px 0 40px;

    a {
      display: flex;
      align-items: center;
      column-gap: 10px;
      text-transform: uppercase;
    }

    .tag_items {
      padding-right: 130px;
    }
  }

  .related_posts_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    row-gap: 30px;
    column-gap: 30px;
    span {
      font-size: 14px;
      color: #FF06B7;
      text-transform: uppercase;
    }

    .related_post_item {
      background: #0d102d;
      row-gap: 15px;
      font-size: 18px;
      padding: 10px 25px 10px 10px;
      .related_post__title {
        display: flex;
        flex-direction: column;
      }
      .related_post__title_first{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 5px;
      }

      &.next {
        padding: 10px 10px 10px 25px;
        margin-left: auto;

        .related_post__title {
          text-align: right;
        }
      }
    }
  }

  .comment_section_title {
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 0;
  }

  @media (max-width: 1024px) {
    .post_title{
      font-size: 40px;
    }

    .related_posts_wrapper {
      .related_post_item {
        padding-right: 18px;

        &.next {
          padding-left: 18px;
        }

        font-size: 16px;
      }
    }
  }

  @media (max-width: 667px) {
    .blog_post_details_wrapper {
      padding-bottom: 100px;
    }

    .post_title {
      width: 100%;
      font-size: 32px;
    }
    blockquote,
    .blockquote {
      &::before {
        top: 0;
      }
    }

    .related_posts_wrapper {
      flex-direction: column;
      justify-content: center;
      .related_post_item {
        width: 100%;
      }
    }

    .blog_post_meta {
      flex-direction: column;
      row-gap: 15px;
    }

  }

  @media (max-width: 540px) {
    .blog_post_details_wrapper {
      padding-bottom: 80px;
    }

    .post_thumbnail {
      height: 400px;
    }

    .post_title {
      font-size: 28px;
    }

    .blog_details {
      padding: 30px;
    }

    .post_tags_list {
      flex-direction: column-reverse;
      row-gap: 20px;
      .tag_items {
        padding-right: 0;
      }

      .share_butn {
        margin-left: 0;
      }
    }
  }
`;

export default BlogDetailsStyleWrapper;
